module.exports = __webpack_public_path__ + "static/media/b2fd1c3b.jpg";